import axios from 'axios';
import partnerCodeHandler, { splashPageHandler } from "./interceptor";
import { buildUrlForEpcs } from '../utils/buildUrlForEpcs';

axios.interceptors.request.use(request => partnerCodeHandler(request));

axios.interceptors.response.use(splashPageHandler, error => {
  return Promise.reject(error);
})

const endpoint_url = process.env.REACT_APP_LOCAL ? "http://localhost:8883" : "";
const api_initialize = "/payment/initialize";
const api_status = "/payment/status";

export function initialize(partnerCode, promoCode ){
  return axios.get(`${endpoint_url}${api_initialize}`, { headers: {'promocode' : promoCode}, partnerCode, handlerEnabled: true});
}

export function status(statusRequestBody, partnerCode, appId, omniStreamlined, towReason, towDistance, promoCode, tokenRefGuid) {
  let url = `${endpoint_url}${api_status}`;
  if (towReason || towDistance) {
    url = buildUrlForEpcs({ startUrl: url, towReason, towDistance });
  }
  const headers = { appid: appId, streamlined: omniStreamlined, promocode: promoCode };
  if(tokenRefGuid){
    headers.previousEpcsTokenRefGuid = tokenRefGuid;
  }
  return axios.post(url, statusRequestBody, {
    headers,
    partnerCode,
    handlerEnabled: true,
  });
}
